import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router";
import api from "../../services/api";
import { Toast } from "../../shared/Toast";
import leftSvg from "../../assets/images/left.svg";
import rightSvg from "../../assets/images/right.svg";
import { roles } from "../../utils/constants";
function EncDiscountApprove() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [discountObj, setDiscountObj] = useState({});
  const [rejectMessage, setRejectMessage] = useState("");
  const [rejectClick, setRejectClick] = useState(false);
  const [approveClick, setApproveClick] = useState(false);
  const [approveMessage, setApproveMessage] = useState("");
  const [currentWonder, setCurrentWonder] = useState(0);
  const [discountArray, setDiscountArray] = useState([]);

  useEffect(()=>{
    let role = localStorage.getItem('role')
    if( !(role === roles.salesperson || role === roles.legalperson)){
        navigate('/')
    }
   })
   
  const handleleftClick = () => {
    if(discountArray.length === 0) return
    if (currentWonder === 0) {
      setCurrentWonder(discountArray.length - 1);
      setDiscountObj(discountArray[discountArray.length - 1])
    } else {
      setDiscountObj(discountArray[currentWonder - 1])
      setCurrentWonder((prevWonder) => prevWonder - 1);
    }
    setRejectClick(false)
  };
  const handlerightClick = () => {
    if(discountArray.length === 0) return
    if (currentWonder === discountArray.length - 1) {
      setCurrentWonder(0);
      setDiscountObj(discountArray[0])
    } else {
      setCurrentWonder((prevWonder) => prevWonder + 1);
      setDiscountObj(discountArray[currentWonder + 1])
    }
    setRejectClick(false)
  };

  const handleClick = (index) => {
    setCurrentWonder(index);
    setDiscountObj(discountArray[index])
    setRejectClick(false)
  };
  const getObject = async (id) => {
    try {
      const objectResult = await api({
        url: "discount/",
        method: "POST",
        responseType: "json",
        data: { id: id },
      });
      if (objectResult?.code === 200) {
        const respObject = objectResult?.data;
        if (respObject.discStatus === 1) {
          Toast("error", "Already Approved");
          localStorage.removeItem("discount-obj");
          navigate("/home/lineitems/discountApprove");
          return;
        } else if (respObject.discStatus === 2) {
          Toast("error", "Already Rejected");
          localStorage.removeItem("discount-obj");
          navigate("/home/lineitems/discountApprove");
          return;
        } else if (respObject.discStatus === 3) {
          // Toast("error", "Discount has been Expired 222");
          localStorage.removeItem("discount-obj");
          navigate("/home/lineitems/discountApprove");
          return;
        } else if (respObject.discStatus === 4) {
          Toast("error", "Discount has been Modified");
          localStorage.removeItem("discount-obj");
          navigate("/home/lineitems/discountApprove");
          return;
        } else if (respObject.discStatus === 5) {
          Toast("error", "UnAuthorized Action");
          localStorage.removeItem("discount-obj");
          navigate("/pageNotFound");
          return;
        } else if (respObject.discStatus === 6) {
          setDiscountArray(respObject.discObj);
          setDiscountObj(respObject.discObj[0]);
          return;
        }
      }
    } catch (error) {
      console.log("Error @ EncDiscountApprove", error);
    }
  };
  const ApproveRejectDisc = async (action) => {
    try {
      let reqObj = {
        payload : {
          campaign_id: +discountObj.campaign_id,
          discount_no: +discountObj.discount_obj.discount_no,
          discountPrice: +discountObj.discount_obj.discountPrice,
          time: discountObj.discount_obj.time,
          actualPrice: +discountObj.discount_obj.actualPrice,
          discReq: +discountObj.discount_obj.discReq,
          role: discountObj.discount_obj.role
        },
        action,
      };
      if (action === "reject") reqObj.message = rejectMessage;
      if (action === "approve") reqObj.message = approveMessage;
      const actionResult = await api({
        url: "/lineitems/approveRejectDiscByPanel",
        method: "POST",
        responseType: "json",
        data: reqObj,
      });
      if (actionResult?.code === 200) {
        const respObject = actionResult?.data;
        if (respObject.discStatus === 1) {
          Toast("error", "Already Approved");
          return;
        } else if (respObject.discStatus === 2) {
          Toast("error", "Already Rejected");
          return;
        } else if (respObject.discStatus === 3) {
          Toast("error", "Discount has been Expired 333");
          return;
        } else if (respObject.discStatus === 4) {
          Toast("error", "Discount has been Modified");
          return;
        } else if (respObject.discStatus === 5) {
          Toast("error", "UnAuthorized Action");
          localStorage.removeItem("discount-obj");
          navigate("/pageNotFOund");
          return;
        } else if (respObject.discStatus === 6) {
          Toast(
            "success",
            action === "reject"
              ? "Rejected Successfully"
              : "Approved Successfully"
          );
          if(discountArray.length > 1){
            const newArray = [...discountArray];
            newArray.splice(currentWonder, 1);
        
            // Update the state with the new array
            setDiscountArray(newArray); 
            if(currentWonder === discountArray.length - 1)
            {setDiscountObj(discountArray[currentWonder -1]);
              setCurrentWonder(prevWonder => prevWonder - 1)}
            else{ setDiscountObj(discountArray[currentWonder + 1])
            setCurrentWonder(prevWonder => prevWonder + 1)}
            setRejectClick(false)
          }
          else{
              setDiscountObj({})
              setDiscountArray([])
          }
          return;
        }
      }
    } catch (error) {
      console.log("Error @ ApproveRejectDisc", error);
    }
  };

  useEffect(() => {
    getObject(id);
  }, []);
  return (
    <>
      <div className="slider-body">
        <h1 className="text-center">Discount Approvals</h1>
        <div className="slider">
          <div className="icon">
            <img onClick={handleleftClick} src={leftSvg} alt="left" />
          </div>

          {Object.keys(discountObj).length ? (
            <div className="mx-auto  w-96 px-2  relative">
              <div className=" px-2 py-4">
                <p className=" py-2 bg-gray-200 text-center fw-bold">{`${
                  discountObj?.campaign_name ? discountObj?.campaign_name : ""
                }`}</p>
                <div className="flex  mb-2">
                  <label className="w-40 text-slate-500">LineItem Name : </label>
                  <span>{discountObj?.campaign_name}</span>
                </div>
                <div className="flex  mb-2">
                  <label className="w-40 text-slate-500">LineItem Type : </label>
                  <span>{discountObj?.campaign_type}</span>
                </div>
                <div className="flex  mb-2">
                  <label className="w-40 text-slate-500">Company Name : </label>
                  <span>{discountObj?.company_name}</span>
                </div>
                <div className="flex  mb-2">
                  <label className="w-40 text-slate-500">Sales Name : </label>
                  <span>{discountObj?.salesname}</span>
                </div>
                <div className="flex  mb-2">
                  <label className="w-40 text-slate-500">CST Name : </label>
                  <span>{discountObj?.discount_obj?.cst_name}</span>
                </div>
                <div className="flex  mb-2">
                  <label className="w-40 text-slate-500">Type : </label>
                  <span>{discountObj?.type}</span>
                </div>
                <div className="flex  mb-2">
                  <label className="w-40 text-slate-500">Actual Price : </label>
                  <span>{`₹${discountObj?.discount_obj?.actualPrice}`}</span>
                </div>
                <div className="flex  mb-2">
                  <label className="w-40 text-slate-500">
                    Discount Requested :{" "}
                  </label>
                  <span>{`${
                    discountObj?.discount_obj?.discsign ? "+" : "-"
                  } ₹${Math.abs(
                    discountObj?.discount_obj?.actualPrice -
                      discountObj?.discount_obj?.discountPrice
                  ).toFixed(2)} (${
                    discountObj?.discount_obj?.discsign ? "+" : "-"
                  } ${discountObj?.discount_obj?.discount_no}%)`}</span>
                </div>
                <div className="flex  mb-2">
                  <label className="w-40 text-slate-500">After Discount : </label>
                  <span>{`₹${discountObj?.discount_obj?.discountPrice}`}</span>
                </div>
                {discountObj?.discount_obj?.discReas ? (
                  <div className="flex mb-2">
                    <label className="w-40 text-slate-500">Discount Reason : </label>
                    <span>{discountObj?.discount_obj?.discReas}</span>
                  </div>
                ) : null}
                {rejectClick ? (
                  <div className="flex mb-2">
                    <label className="w-40 text-slate-500">Rejected Reason : </label>
                    <p className="w-72">{rejectMessage}</p>
                  </div>
                ) : null}
                
                  {approveClick ? (
                    <div className="flex mb-2">
                      <label className="w-40 text-slate-500">Approve Reason : </label>
                      <p className="w-72">{approveMessage}</p>
                    </div>
                  ) : null}
                
                <div className="d-flex gap-3">
                  {(!rejectClick && !approveClick )&& <button
                    type="submit"
                    className="btn btn-success w-1/2"
                    onClick={() => setApproveClick(true)}
                  >
                    Approve
                  </button>}
                  {(!rejectClick && !approveClick )&& (
                    <button
                      className="btn btn-danger w-1/2"
                      onClick={() => setRejectClick(true)}
                    >
                      Reject
                    </button>
                  )}
                  </div>
                  {rejectClick && (
                    <>
                    <div>
                      <input
                        placeholder="Reject is Required"
                        className="form-control mb-2"
                        type="text"
                        name="rejectMessage"
                        value={rejectMessage}
                        onChange={(e) => setRejectMessage(e.target.value)}
                      />
                      </div>
                      <div className="d-flex gap-3">
                      <button
                        className="btn btn-danger w-full"
                        onClick={() => ApproveRejectDisc("reject")}
                        disabled={!rejectMessage}
                      >
                        Reject
                      </button>
                      <button
                        className="btn btn-danger w-full"
                        onClick={()=>{setRejectClick(false); setRejectMessage("")}}
                      >
                        Cancel
                      </button>
                      </div>
                      
                    </>
                  )}
                  {approveClick && (
                    <>
                    <div>
                      <input
                        placeholder="Approve message is Required"
                        className="form-control mb-2"
                        type="text"
                        name="rapproveMessage"
                        value={approveMessage}
                        onChange={(e) => setApproveMessage(e.target.value)}
                      />
                    </div>
                      <div className="d-flex gap-2">
                      <button
                        className="btn btn-success w-full"
                        onClick={() => ApproveRejectDisc("approve")}
                        disabled={!approveMessage}
                      >
                        Approve
                      </button>
                      <button
                        className="btn btn-danger w-full"
                        onClick={()=>{setApproveClick(false); setApproveMessage("")}}
                      >
                        Cancel
                      </button>
                      </div>
                      
                    </>
                  )}
                
                <div className="slider-points py-3 bg-gray-200 my-2">
            {Array.from(discountArray, (wonder, index) => (
              <div
                className={`slider-icon ${
                  index === currentWonder ? "active-discount" : ""
                }`}
                key={index}
                onClick={() => handleClick(index)}
              ></div>
            ))}
          </div>
              </div>
            </div>
          ) : <div className='no-data'>
          <svg data-v-5eed88b5="" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" class="bird-icon flip" strokeWidth="1"><path d="M16 7h.01"></path><path d="M3.4 18H12a8 8 0 0 0 8-8V7a4 4 0 0 0-7.28-2.3L2 20"></path><path d="m20 7 2 .5-2 .5"></path><path d="M10 18v3"></path><path d="M14 17.75V21"></path><path d="M7 18a6 6 0 0 0 3.84-10.61"></path></svg>
            <h2>No Data Found</h2>
          </div>}
          <div className="icon">
                <img onClick={handlerightClick} src={rightSvg} alt="right" />
              </div>
        </div>
        
      </div>
    </>
  );
}
export default EncDiscountApprove;
